import React, { useState } from 'react';
import './CSS/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <div className="navbar-container">
      {/* Logo */}
      <div className="logo-container">
        <img src='/assets/images/ayavet_logo.png' alt="Logo" className="logo" />
        <h1 className="navbar-title">AyAVET Clínica Veterinaria</h1>
      </div>

      {/* Enlaces de navegación */}
      <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
        <li><a href="#home" onClick={handleLinkClick}>Inicio</a></li>
        <li><a href="#services" onClick={handleLinkClick}>Servicios</a></li>
        <li><a href="#employees" onClick={handleLinkClick}>Equipo</a></li>
        <li><a href="#careers" onClick={handleLinkClick}>Trabaja con nosotros</a></li>
        <li><a href="#clientes" onClick={handleLinkClick}>Pacientes</a></li>
        <li><a href="#contact" onClick={handleLinkClick}>Contacto</a></li>
      </ul>

      {/* Ícono de hamburguesa */}
      <div
        className={`nav-toggle ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Navbar;